import {Material, MaterialType} from '@hconnect/common/types'
import {CementIcon, ClinkerIcon, dataTestId} from '@hconnect/uikit'
import {Box, Skeleton, Stack, StackProps, Typography, SvgIconProps} from '@mui/material'

import {useHistoryMaterialsById} from '../../../shared/hooks/api/materials/useHistoryMaterialsById'
import {MomentRange} from '../../../shared/selectors/time'
import {usePlanningChartStartEnd} from '../../page-planning/dailyPlanning/PlanningChartStartEndProvider'

import {OptimizerStockMillETAIndicator} from './OptimizerStockMillETAIndicator'

type OptimizerStockLevelInfoProps = {
  material: Material
} & StackProps

const iconStyle: SvgIconProps = {
  style: {
    marginRight: '4px'
  },
  height: '16px'
}
export const OptimizerStockLevelInfo = ({material, ...restProps}: OptimizerStockLevelInfoProps) => {
  const materialId = material.id

  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()
  const planTimeFrame: MomentRange = [startOfPlan, endOfPlan]
  const {data: materialsById} = useHistoryMaterialsById({timeFrame: planTimeFrame})

  if (!materialsById) {
    return <Skeleton variant="rectangular" />
  }

  if (!material) {
    throw new Error(`Material ${materialId} not found`)
  }

  const icon =
    material.type === MaterialType.Cement ? (
      <CementIcon {...iconStyle} />
    ) : (
      <ClinkerIcon {...iconStyle} />
    )

  return (
    <Stack
      {...restProps}
      direction="row"
      alignItems="center"
      spacing={1}
      {...dataTestId('optimizer_stock_levels_info')}
    >
      <Box display="flex" alignItems="center">
        {icon} <Typography variant="body2">{material.name}</Typography>
      </Box>
      <Typography variant="caption" {...dataTestId('optimizer_stock_levels_mill_eta')}>
        <OptimizerStockMillETAIndicator material={material} />
      </Typography>
    </Stack>
  )
}
